<template>
  <div class="emerbox">
    <div class="panel-l">
      <div class="item" :class="{activeSel:selectIndex===index}" @click="change(item,index)" v-for="(item,index) in supplyList" :key="index">
        {{item.name}}
      </div>
    </div>
    <div class="panel-r" style="height:550px; overflow-y:auto">
      <div v-for="(item,i) in supplyModel" :key="i" v-show="'model' + selectIndex === i" class="panel-d">
        <div v-for="(m,k) in item" :key="k" class="panel-d-t">
          <p>
            <span>{{m.name}}</span>
            <span>{{m['count']}}</span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import workbrnch from './../../data/emer/burst.js'
import supply from '../../data/emer/supply.js'
export default {
  data() {
    return {
      supplyList: [],
      selectIndex: 0,
      charildArr: [],
      num1: '',
      supplyModel: {},
      params: {},
      countRes: {},
      countResArr: [],
      options: [{
        value: '11000',
        label: '应急监测仪器',
        model: 0,
      }, {
        value: '12000',
        label: '个人防护类物资',
        model: 1,
      }, {
        value: '13000',
        label: '污染控制类物资',
        model: 2,
      }, {
        value: '14000',
        label: '其他物资',
        model: 3,
      }],
      isSave: false
    }
  },
  watch: {
    supplyModel: {
      handler(newVal, oldVal) {
        this.get_format_res()
        if (!this.params.emergencyMaterial.length) return
      },
      deep: true
    }
  },
  created() {
    let _this = this;
    this.get_supply_tree().then(function (result) {
      _this.get_list()
    })
  },
  methods: {
    change(item, index) {
      this.selectIndex = index
    },

    get_list() {
      (async() => {
        try {
          let info = await workbrnch.material_listss({
            planId: sessionStorage.planIdLists,
          })

          if (info.status) {
            this.params = {
              planId: sessionStorage.planIdval,
              emergencyMaterial: info.data
            }
            this.get_format_supplyModel(info.data);
          }
        } catch (err) {
          console.log(err)
        }
      })()
    },
    //格式化选中的物质
    get_format_supplyModel (data) {
      let self = this;
      let ids = data.map(item => {return item.materialId});
      ids = ids.join(',');
      (async() => {
        try {
          let info = await supply.search({
            ids: ids,
            size: 1000000
          });
          this.supplyModel = {
            model0: {},
            model1: {},
            model2: {},
            model3: {},
          }
          let parentInfoData = info.content;
          for(let i = 0; i< parentInfoData.length; i++) {
            let nowData = data.filter((item) => {
              return item.materialId == parentInfoData[i].id;
            })[0]
            let model = self.options.filter((item) => {
              return item.value == parentInfoData[i].parent;
            })[0].model;
            this.supplyModel['model' + model][i] = {};
            this.supplyModel['model' + model][i]['name'] = nowData.name;
            this.supplyModel['model' + model][i]['count'] = nowData.count;
            this.supplyModel['model' + model][i]['materialId'] = nowData.materialId;
          }
          this.get_format_res()
        } catch (err) {
          this.loading = false;
          console.log(err)
        }
      })()
    },

    // 获取格式化后的 信息
    get_format_res() {
      let newArr = [] // 存储一级 model
      let arr = [] // 存储所有model的子元素
      let res = [] // 过滤所有大于0的元素
      let newInfo = []
      let countRes = Object.assign({}, this.countRes)

      this.supplyList.map((item, i) => {
        newArr.push(this.supplyModel['model' + i])
      })

      for (let i = 0; i < newArr.length; i++) {
        for (let k in newArr[i]) {
          arr.push(newArr[i][k])
          countRes['count' + i] = parseInt(countRes['count' + i]) + parseInt(newArr[i][k].count)
        }
      }
      // 过滤
      arr.map(item => {
        if (item.count >= 1) res.push(item)
      })
      for (let m in countRes) {
        newInfo.push(countRes[m])
      }
      this.countResArr = newInfo

      this.params = {
        planId: sessionStorage.planIdval,
        emergencyMaterial: res
      }
    },
    // 验证`
    verifyResult() {
      if (!this.params.emergencyMaterial.length) {
        return {
          status: false,
          msg: '应急物资信息不完善，请填写'
        }
      }
      return {
        status: true,
        msg: 'ok'
      }
    },
    rest() {
      this.params = {}
      this.supplyModel = {}
      this.get_supply_tree()
    },

    // 获取树形目录
    get_supply_tree() {
      return new Promise((resolve, reject) => {
        (async() => {
          try {
            let info = await workbrnch.supply_tree()
            this.supplyList = info.data[0].children
            let newModel = {}
            let countModel = {}
            this.supplyList.map((item, i) => {
              newModel['model' + i] = {}
              countModel['count' + i] = 0
            })
            this.supplyModel = newModel
            this.countRes = countModel
            resolve(1);
          } catch (err) {
            this.$message.error('网络错误，请稍后重试')
            reject(1);
          }
        })()
      });

    }
  }
}

</script>
<style scoped lang="stylus">
.emerbox {
  width: 100%;
  height: auto;
  min-height: 150px;
  display: flex;
}

.item {
  overflow: hidden;
  width: 150px;
  line-height: 30px;
  cursor: pointer;
  text-indent: 10px;
  font-size: 14px;
}

.panel-l {
  margin-top: 15px;
  margin-bottom: 15px;
  width: 200px;
  font-size: 14px;
  border-right: 2px #eef1f6 solid;
  .item {
    button {
      padding: 3px 5px;
      float: right;
      margin-right: 10px;
      margin-top: 19px;
    }
  }
}

.panel-r {
    margin-top: 15px;
  overflow: auto;
  box-sizing: border-box;
  .panel-d {
    .panel-d-t {
      box-sizing: border-box;
      padding: 0 20px;
      line-height: 30px;
      float: left;
      width: 100%;
      p {
        width: 100%;
        span {
          width: 150px;
          font-size: 13px;
          float: left
          &:last-child {
            width: 50px;
          }
        }
        div {
          display: inline-block;
          position: relative;
          top: 15px;
          float: right;
        }
      }
    }
  }
}
.item.activeSel {
  color: #20a0ff;
  border-left: 2px solid #20a0ff;
}

.circle {
  padding: 0px 3px;
  border-radius: 100%;
  background: #00c0ef;
  color: #fff;
  margin-left: 10px;
  font-size: 13px;
}

</style>



// WEBPACK FOOTER //
// detail_one.vue?e309551c